
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';

export const useEditMode = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const { toast } = useToast();
  
  const toggleEditMode = () => {
    setIsEditMode(prev => {
      const newState = !prev;
      
      if (newState) {
        toast({
          title: "Customize Mode Enabled",
          description: "You can now drag and drop, edit, or hide dashboard cards."
        });
      } else {
        toast({
          title: "Layout Saved",
          description: "Your dashboard layout has been saved."
        });
      }
      
      return newState;
    });
  };
  
  return {
    isEditMode,
    toggleEditMode
  };
};
